<app-widget-card-wrapper title="Maramataka indicators over time">
  <div class="card-stretch">
    <img src="assets/wai-indicators-graph.png" class="img-fluid" style="max-height: 265px" />
  </div>
</app-widget-card-wrapper>
